export default {
  orderDetails: 'Order Details',
  'orderDetails.orderReference': 'Order reference: {{reference}}',
  'orderDetails.payAmount': 'Pay {{amount}}',
  'orderDetails.installmentNumber': 'Installment {{number}}',
  'orderDetails.payBefore': 'Pay before {{date}}',
  'orderDetails.paidOn': 'Paid on {{date}}',
  'orderDetails.payInFull': 'Pay in Full: {{amount}}',
  'orderDetails.purchaseDate': 'Purchase date',
  'orderDetails.paymentStatus': 'Payment Status',
  'orderDetails.orderId': 'Order ID',
  'orderDetails.paymentMethod': 'Payment option',
  'orderDetails.paymentStatus.PAID': 'Paid',
  'orderDetails.paymentStatus.PENDING': 'Pending',
  'orderDetails.button.back.orders': 'Back to orders',
  'orderDetails.button.back.pay-now': 'Back to pay now',
  'orderDetails.button.back.dispatches': 'Back to dispatches',
  'orderDetails.button.back.disputes': 'Back to disputes',
  'orderDetails.button.back.abandoned': 'Back to abandoned',
  'orderDetails.button.back.planned-purchase': 'Back to planned purchase',
  clearFilters: 'Clear filters',
  'order.timeline.MERCHANT': 'Merchant',
  'order.timeline.ADMIN': 'cashew admin',
  'order.timeline.CUSTOMER': 'Customer',
  'order.timeline.SYSTEM': 'System',
  'order.timeline.undefined': 'Guest',
  'timeline.order.title': 'Order timeline',
  'timeline.order.status': 'Order status',
  'timeline.order.payments': 'Payments',
  'timeline.order.filterTitle': 'Order timeline filter',
  'order.timeline.ORDER_CREATED': 'Order created', // ("order created"),
  'order.timeline.ORDER_REJECTION_SET': 'Rejection reason set: "{{reason}}"', // ("rejection reason set"),
  'order.timeline.ORDER_REJECTED': 'Order rejected', // ("order rejected"),
  'order.timeline.ORDER_DISPATCHED': 'Order dispatched', // ("order dispatched"),
  'order.timeline.REFUND_ISSUED': 'Refund of {{currency}} {{amount}} issued',
  'order.timeline.PARTIAL_REFUND_ISSUED':
    'Partial refund of {{currency}} {{amount}} issued',
  'order.timeline.OLD_CARD_USED': 'Card "***{{card}}" used', // ("old card {0} used"),
  'order.timeline.NEW_CARD_ADDED': 'New card "***{{card}}" added successfully',
  'order.timeline.ORDER_PAYMENT':
    '{{instalments}} instalment payment using card "***{{card}}" made successfully',
  'order.timeline.ORDER_PAYMENT_ALL_INSTALLMENTS':
    'Customer manual payment for all remaining instalments using card "***{{card}}" made successfully', // ("customer manually paid all remaining instalments using card {0}"),
  'order.timeline.ORDER_PAYMENT_ALL_INSTALLMENTS_FAIL':
    'Customer manual payment for all remaining instalments using card "***{{card}}" failed', // ("customer manually paid all remaining instalments using card {0}"),
  'order.timeline.AUTO_DEDUCTION_SUCCESS':
    '{{instalments}} instalment auto-deduct using card "***{{card}}" made successfully', // ("{0} instalment auto-deduct success using card {1}"),
  'order.timeline.AUTO_DEDUCTION_FAIL':
    '{{instalments}} instalment auto-deduct using card "***{{card}}" failed', // ("{0} instalment auto-deduct failed"),
  'order.timeline.MANUAL_PAYMENT_SUCCESS':
    '{{instalments}} instalment manual payment using card "***{{card}}" made successfully', // ("{0} instalment manual payment made using card {1}"),
  'order.timeline.ORDER_PAYMENT_FAIL':
    '{{instalments}} instalment manual payment using card "***{{card}}" failed', // ("{0} instalment manual payment made using card {1}"),
  'order.timeline.MANUAL_PAYMENT_FAIL':
    '{{instalments}} instalment manual payment using card "***{{card}}" failed', // ("{0} instalment manual payment made using card {1}"),
  'order.timeline.CUSTOMER_PAY_ALL':
    'Customer manual payment for all remaining instalments using card "***{{card}}" made successfully', // ("customer paid all remaining installments using card {0}"),
  'order.timeline.CUSTOMER_PAY_ALL_FAIL':
    'Customer manual payment for all remaining instalments using card "***{{card}}" failed', // ("customer paid all remaining installments using card {0}"),
  'order.timeline.PAY_NOW_ORDER_PAYMENT': 'Payment made',
  'order.timeline.INSTALLMENT_SNOOZE_SUCCESS':
    '{{instalments}} instalment snoozed successfully using card "***{{card}}"',
  // 'order.timeline.PURCHASE_FEE_PAYMENT': 'Purchase fee paid',
  'order.timeline.PURCHASE_FEE_PAYMENT':
    '{{instalments}} instalment purchase fee payment using card "***{{card}}" made successfully', // ("{0} instalment purchase fee payment made using card {1}"),
  'order.timeline.PAYMENT_CHARGEBACK_DISPUTE':
    'Chargeback claim raise for {{ordinal}} instalment',
  'order.timeline.PAYMENT_CHARGEBACK_SERVICE_BLOCK': 'Chargeback service block',
  'order.timeline.PAYMENT_CHARGEBACK_WON':
    'Chargeback dispute for {{ordinal}} instalment won',
  'order.timeline.PAYMENT_CHARGEBACK_LOST':
    'Chargeback dispute for {{ordinal}} instalment lost',
};
